import * as React from 'react'
import { FC } from 'react'

const Close: FC = () => {
    return (
        <svg className="Close" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.1 21.1">
            <path
                fill="#fff"
                d="M21.1 20l-9.4-9.4 9.4-9.4L20 0l-9.4 9.4L1.2 0 0 1.2l9.4 9.4L0 20l1.2 1.1 9.4-9.4 9.4 9.4z"
            />
        </svg>
    )
}

export default Close
